import { FC } from "react";

const Reopen: FC = () => {
  return (
    
    <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.28988 2.22526V1.00178C6.28988 0.188411 5.37051 -0.284714 4.70864 0.18805L1.88744 2.20319C1.32909 2.60202 1.32909 3.43184 1.88744 3.83066L4.70864 5.84581C5.37051 6.31857 6.28988 5.84544 6.28988 5.03207V3.80859C8.91029 3.80859 11.0399 5.93818 11.0399 8.55859C11.0399 11.179 8.91029 13.3086 6.28988 13.3086C3.93798 13.3086 1.98147 11.5931 1.6052 9.34692C1.53296 8.9157 1.18543 8.55859 0.74821 8.55859C0.310984 8.55859 -0.0486454 8.91481 0.00529182 9.34869C0.393885 12.4746 3.05829 14.8919 6.28988 14.8919C9.78904 14.8919 12.6232 12.0578 12.6232 8.55859C12.6232 5.05943 9.78904 2.22526 6.28988 2.22526Z" fill="#E52514"/>
    </svg>

  );
};

export default Reopen;
